module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"hello@23g.io"},"nl":{"email":"hallo@23g.nl"}}')
  delete Component.options._Ctor
}
